import { StatusType } from '@/types/common';

export const statusColors: Record<StatusType, string> = {
  Active: 'from-[#B6E828] to-[#92CF2F]',
  Inactive: 'from-[#EB5757] to-[#EC3E3E]',
  Pending: 'from-[#FFD452] to-[#FF9900]',
  Declined: 'from-[#EB5757] to-[#EC3E3E]',
  Revise: 'from-[#FF9040] to-[#FF7A00]',
};
